import AppService from '../../AppService';
import iAccess, { iAccessCode } from '../../../types/settings/UserAccess/iAccess';
import iUser from '../../../types/user/iUser';
import { iAccessCanFields } from '../../../types/settings/UserAccess/iRoleAccess';

const endPoint = '/access';

const getAllAccesses = (config = {}): Promise<iAccess[]> => {
  return AppService.get(endPoint, config).then(({ data }) => data);
};

const hasAccess = (accessCode: iAccessCode, canField: iAccessCanFields, user?: iUser) => {
  if (!user) {
    return false;
  }

  const accessMap = user.accessMap || {};
  if (!(accessCode in accessMap)) {
    return false;
  }
  return accessMap[accessCode][canField] || false;
};

export default {
  getAllAccesses,
  hasAccess,
};
